var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import ButtonInCart from './ButtonInCart';
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 24px;\n  margin-top: 8px;\n  margin-bottom: 16px;\n"], ["\n  padding: 0 24px;\n  margin-top: 8px;\n  margin-bottom: 16px;\n"])));
var ListItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var SampleOrderShoppingCart = function (_a) {
    var maxSampleOrderCount = _a.maxSampleOrderCount, sampleOrderedItems = _a.sampleOrderedItems, onOpenSampleOrderForm = _a.onOpenSampleOrderForm;
    var t = useTranslation().t;
    return (React.createElement(Box, { sx: { padding: '12px 16px' } },
        React.createElement(Typography, { variant: "subtitle1", sx: { marginBottom: '0px' } }, t('pages.roasterOrder.sampleOrderCaption')),
        maxSampleOrderCount && (React.createElement(Typography, { variant: "caption", sx: { marginBottom: '0px' } },
            t('pages.roasterOrder.sampleOrderableCount'),
            ":",
            ' ', "".concat(sampleOrderedItems.length, " / ").concat(maxSampleOrderCount))),
        React.createElement(List, null, sampleOrderedItems.map(function (item) { return (React.createElement(ListItem, { key: item.id }, item.offer.lotNumber)); })),
        React.createElement(ButtonInCart, { onClick: onOpenSampleOrderForm, fullWidth: true }, t('pages.roasterOrder.inputAddress'))));
};
export default SampleOrderShoppingCart;
var templateObject_1, templateObject_2;
